var _defs, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _rect, _rect2, _rect3, _g, _line39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_74",
    "data-name": "Group 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 51,
    height: 53,
    fill: "none",
    stroke: "#c11b20",
    strokeWidth: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M21,42.75V9H37.464V42.75",
    transform: "translate(-3.713 -1.591)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 5,
    transform: "translate(3 40)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 5,
    transform: "translate(10 40)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 5,
    transform: "translate(3 37)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 5,
    transform: "translate(10 37)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 5,
    transform: "translate(3 34)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 5,
    transform: "translate(10 34)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 12,
    transform: "translate(3 30)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 5,
    transform: "translate(3 27)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x2: 5,
    transform: "translate(10 27)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 5,
    transform: "translate(36 40)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 5,
    transform: "translate(43 40)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 5,
    transform: "translate(36 37)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 5,
    transform: "translate(43 37)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 12,
    transform: "translate(36 34)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 5,
    transform: "translate(36 30)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 5,
    transform: "translate(43 30)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 5,
    transform: "translate(36 27)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 5,
    transform: "translate(43 27)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 5,
    transform: "translate(36 24)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 5,
    transform: "translate(43 24)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 5,
    transform: "translate(36 21)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 5,
    transform: "translate(43 21)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 11,
    transform: "translate(20 40)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 5,
    transform: "translate(20 37)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 5,
    transform: "translate(26 37)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 5,
    transform: "translate(20 34)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 5,
    transform: "translate(26 34)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 5,
    transform: "translate(20 30)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 5,
    transform: "translate(26 30)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 5,
    transform: "translate(20 27)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 5,
    transform: "translate(26 27)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 11,
    transform: "translate(20 24)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x2: 5,
    transform: "translate(20 21)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 5,
    transform: "translate(26 21)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x2: 5,
    transform: "translate(20 17)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x2: 5,
    transform: "translate(26 17)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x2: 5,
    transform: "translate(20 14)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 5,
    transform: "translate(26 14)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 5,
    transform: "translate(20 11)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 5,
    transform: "translate(26 11)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 10,
    height: 3,
    transform: "translate(4 21)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 10,
    height: 3,
    transform: "translate(37 14)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 9,
    height: 3,
    transform: "translate(21 4)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    y1: 4,
    transform: "translate(26)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M4.293,56.988H1V29H17.464",
    transform: "translate(-0.177 -5.128)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M41,21H57.464V55.574H54.171",
    transform: "translate(-7.25 -3.713)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 43,
    height: 8,
    transform: "translate(4 44)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    y2: 6,
    transform: "translate(17 46)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    y2: 6,
    transform: "translate(34 46)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 43,
    transform: "translate(4 49)",
    fill: "none",
    stroke: "#c11b20",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.6b61435a7ac2a065591b3f90411af1f8.svg";
export { ForwardRef as ReactComponent };